<template>
    <main>
        <crumbs :crumbs="crumbs"></crumbs>
        <div class="wrap">
            <div class="form-box">
                <div class="title-box">
                    <div class="title">联系我们</div>
                    <div class="line"></div>
                </div>
                <div class="form">
                    <div class=" item">
                        <div class="tit"><i>*</i>姓名</div>
                        <div class="input" :class="[error.username ? 'error' :'']"><input type="text" @blur="validate('username')" placeholder="请输入您的姓名" v-model="form.username"></div>
                        <div class="validate">{{error.username}}</div>
                    </div>
                    <div class=" item">
                        <div class="tit"><i>*</i>手机号</div>
                        <div class="input" :class="[error.phone ? 'error' :'']"><input type="text" @blur="validate('phone')" placeholder="请输入您的手机号" v-model="form.phone"></div>
                        <div class="validate">{{error.phone}}</div>
                    </div>
                    <div class=" item">
                        <div class="tit"><i>*</i>邮箱</div>
                        <div class="input" :class="[error.email ? 'error' :'']"><input type="text" @blur="validate('email')" placeholder="请输入您的邮箱" v-model="form.email"></div>
                        <div class="validate">{{error.email}}</div>
                    </div>
                    <div class=" item">
                        <div class="tit"><i>*</i>地址</div>
                        <div class="input" :class="[error.address ? 'error' :'']"><input type="text" @blur="validate('address')" placeholder="请输入您的地址" v-model="form.address"></div>
                        <div class="validate">{{error.address}}</div>
                    </div>
                    <div class=" item">
                        <div class="tit"><i>*</i>公司</div>
                        <div class="input" :class="[error.company ? 'error' :'']"><input type="text" @blur="validate('company')" placeholder="请输入您的公司" v-model="form.company"></div>
                        <div class="validate">{{error.company}}</div>
                    </div>
                    <div class=" item">
                        <div class="tit"><i>*</i>部门</div>
                        <div class="input" :class="[error.department ? 'error' :'']"><input type="text" @blur="validate('department')" placeholder="请输入您的部门" v-model="form.department"></div>
                        <div class="validate">{{error.department}}</div>
                    </div>
                    <div class=" item">
                        <div class="tit"><i>*</i>工作角色</div>
                        <div class="input" :class="[error.job ? 'error' :'']"><input type="text" @blur="validate('job')" placeholder="请输入您的工作角色" v-model="form.job"></div>
                        <div class="validate">{{error.job}}</div>
                    </div>
                    <div class=" item">
                        <div class="tit"><i>*</i>国家/地区</div>
                        <div class="input" :class="[error.country ? 'error' :'']"><input type="text" @blur="validate('country')" placeholder="请输入您所在的国家/地区" v-model="form.country"></div>
                        <div class="validate">{{error.country}}</div>
                    </div>
                    <div class=" item item-l">
                        <div class="tit">详细信息</div>
                        <div class="input">
                            <textarea name="" id="" cols="30" rows="10" placeholder="请输入您要咨询详细信息，如产品名称、颜色等" v-model="form.message"></textarea>
                        </div>
                    </div>
                </div>
                <div class="rule-box item-select">
                    <div class="tit">
                        <label><input type="checkbox" v-model="form.agree_contact2" true-value="1" false-value="2" name="agree"><i class="i"></i>
                            <span style="font-size: .22rem;">我了解并同意以下内容：戴尔按照<a target="_blank" rel="noopener noreferrer" href="https://www.dell.com/zh-cn/lp/legal/policies-privacy" style="color: #007db8;">《隐私声明》</a>所述，根据《个人信息保护法》的规定，将本人个人信息传输、存储至戴尔美国总部进行处理。要详细了解戴尔如何使用、共享和保护您的个人数据，请参阅我们的 <a target="_blank" rel="noopener noreferrer" href="https://www.dell.com/zh-cn/lp/legal/policies-privacy" style="color: #007db8;">隐私声明</a>。<br><div class="privacy-statement-text" style="margin-top: 10px;">单击"提交"，即表示您同意 <a target="_blank" rel="noopener noreferrer" href="https://investors.delltechnologies.com/node/11831/html" style="color: #007db8;">Dell Technologies 及其公司集团</a>（简称"戴尔"）通过电子邮件、电话或短信与您保持联系。戴尔及其销售代表将向您提供有关产品、服务、解决方案、专享优惠和特别活动的最新信息。有关信息处理方式的更多详细信息，请参见我们的 <a target="_blank" rel="noopener noreferrer" href="https://www.dell.com/zh-cn/lp/legal/policies-privacy" style="color: #007db8;">隐私声明</a>。您可以随时取消订阅。</div></span>
                        </label>
                    </div>
                    <div class="validate">{{error.agree_contact2}}</div>
                </div>
                <div class="submit">
                    <div class="btn" @click="submit">提交</div>
                </div>
            </div>
            <div class="address-box">
                <div class="title">联系地址</div>
                <div class="line"></div>
                <div class="list">
                    <div class="cen">
                        <div class="left item">
                            <div class="middle">
                                <div class="icon icon-logo"><img :src="require('@/assets/image/41.png')" alt=""></div>
                                <div class="tit">{{adv1.title}}</div>
                                <div class="address">{{adv1.min_title}}</div>
                            </div>
                        </div>
                        <div class="left item">
                            <div class="middle">
                                <div class="icon icon-tel"><img :src="require('@/assets/image/42.png')" alt=""></div>
                                <div class="tit">{{adv2.title}}</div>
                                <div class="address"><a :href="'tel:'+adv2.min_title">{{adv2.min_title}}</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import Crumbs from "../../../components/m/Crumbs";
    export default {
        name: 'dell',
        data() {
            return {
                query:"",
                form:{
                    agree_contact2:2
                },
                error:{},
                adv1:{},
                adv2:{}
            }
        },
        components:{
            Crumbs
        },
        computed:{
            crumbs() {
				return {title:"联系戴尔",min_title:"Contact dell"}
            },
        },
        methods: {
            validate(field){
                var message = "";
                switch (field) {
                    case 'username':
                        if(!this.form.username){
                            message = "请输入您的姓名";
                        }else{
                            message = "";
                        }
                        break;
                    case 'phone':
                        if(!this.form.phone){
                            message = "请输入手机号";
                        }else if(this.isCn() && !this.tool.type.checkStr(this.form.phone,'phone') ){
                            message = "手机号格式不正确";
                        }else{
                            message = "";
                        }
                        break;
                    case 'email':
                        if(!this.form.email){
                            message = "请输入您的邮箱";
                        }else if(!this.tool.type.checkStr(this.form.email,'email') ){
                            message = "邮箱格式不正确";
                        }else{
                            message = "";
                        }
                        break;
                    case 'address':
                        if(!this.form.address){
                            message = "请输入您的地址";
                        }else{
                            message = "";
                        }
                        break;
                    case 'company':
                        if(!this.form.company){
                            message = "请输入您的公司";
                        }else{
                            message = "";
                        }
                        break;
                    case 'department':
                        if(!this.form.department){
                            message = "请输入您的部门";
                        }else{
                            message = "";
                        }
                        break;
                    case 'job':
                        if(!this.form.job){
                            message = "请输入您的工作角色";
                        }else{
                            message = "";
                        }
                        break;
                    case 'country':
                        if(!this.form.country){
                            message = "请输入您所在的国家/地区";
                        }else{
                            message = "";
                        }
                        break;
                    case 'agree_contact2':
                        if(this.form.agree_contact2 != 1 && this.form.agree_contact2 != '1'){
                            message = "请先阅读并同意戴尔隐私声明和销售条款";
                        }else{
                            message = "";
                        }
                        break;
                    default:
                        break;
                }
                this.setError(field,message);
                return message ? false : true;
            },
            setError(name,message =""){
                this.error[name] = message;
                this.$forceUpdate();
            },
            validateAll(){
                var username = this.validate("username");
                var phone = this.validate("phone");
                var email = this.validate("email");
                var address = this.validate("address");
                var company = this.validate("company");
                var department = this.validate("department");
                var job = this.validate("job");
                var country = this.validate("country");
                var agree_contact2 = this.validate("agree_contact2");
                if(!username || !phone || !email || !address || !company || !department || !job || !country || !agree_contact2 ){
                    return false;
                }else{
                    return  true;
                }
            },
            submit(){
                var res = this.validateAll();
                if(!res){return false;}
                this.form.agree_contact = this.form.agree_contact2;

                gio('track', 'DTF2021_contactSubmit', {
                    //'userName':this.form.username,
                    'phoneNumber':this.util.encryptPhone(this.form.phone),
                    //'company' : this.form.company,
                    //'email' :this.form.email,
                });

                this.http.request({
                    api:"feedback/submit",
                    data:this.form,
                    loading:true,
                    success:(res)=>{
                        this.$toast.success("提交成功");
                        this.form = {};
                    }
                })
            },
            isCn(){
                return true;
            },
            setForm(){
                var user = this.$store.state.user_info;
                this.form.username = user.username;
                this.form.phone = user.phone;
                this.form.email = user.email;
                this.form.company = user.company;
                this.form.department = user.department;
                this.form.job = user.job;
                this.$forceUpdate();
            }
        },
        mounted() {
            this.query = this.$route.query;
            this.setForm();
            this.util.showBottom(true);
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .wrap{background:#f6f6f6 url("~@/assets/image/2021/17_m.png") no-repeat bottom center;background-size:100% auto;padding-top: .25rem;
        .form-box{background: #fff;padding: .5rem;
            .title{font-size: .28rem;text-align: center;}
            .line{width:1.3rem;height:.04rem;background: #1D56C0;margin: .05rem auto 0;}
            .form{margin-top: .2rem;overflow: hidden;
                .item{
                    .tit{font-size: .22rem;color:#565656;
                        i{color: red;margin-right:.02rem;}
                    }
                    .input{margin-top:.05rem;border: .02rem solid #d4d4d4;
                        input{display: block;width: 6rem;height:.4rem;line-height: .4rem; padding: .15rem .2rem; background: none;font-size:.24rem;border:none;}
                        textarea{font-size: .24rem; width:6rem;height:1.8rem;border:none;padding:.15rem .2rem;}
                    }
                    .input.error{border-color: red;}
                    .validate{height:.4rem;line-height:.4rem;font-size:.22rem;color:red;}
                }
                .item:nth-child(2n){float: right;}
            }
            .check-box{margin-top: .4rem;
                .tit{font-size: .26rem;line-height:.4rem;
                    i{color:red;}
                }
                .check{font-size: .22rem;overflow: hidden;
                    label{margin-right:.5rem;height:.6rem;line-height: .6rem;cursor: pointer;display: block;float: left;overflow: hidden;
                        input{display: none;}
                        input[type=radio]+i{display: block;float: left; width:.45rem;height:.6rem;background: url("~@/assets/image/a2.png") no-repeat left center;background-size: .34rem;transition: all .3s ease;}
                        input[type=radio]:checked+i{background: url("~@/assets/image/2024/mobile/radio1.png") no-repeat left center;background-size:.34rem;transition: all .3s ease;}
                        span{display: block;float: left;}
                    }
                }
                .validate{clear: both; height:.4rem;line-height:.4rem;font-size:.22rem;color:red;}
            }
            .rule-box{margin-top: .4rem;
                .tit{font-size: .26rem;line-height:.4rem;vertical-align: middle;
                    input{display: none;}
                    span{display: block;float: left;width: 5.9rem;}
                    input[type=checkbox]+.i{display: block;float: left;width:.45rem;height:.4rem;background: url("~@/assets/image/a4.png") no-repeat left center;background-size: .34rem;transition: all .3s ease;}
                    input[type=checkbox]:checked+.i{background: url("~@/assets/image/2024/check1.png") no-repeat left center;background-size: .34rem;transition: all .3s ease;}
                }
                .validate{clear: both;height:.4rem;line-height:.4rem;font-size:.22rem;color:red;}
            }
            .submit{
                .btn{width:2.9rem;height:.7rem;text-align: center;line-height: .7rem;color:#fff;background: #1D56C0;font-size: .28rem;cursor: pointer;transition: all .3s ease;margin: .4rem auto 0;border-radius: .05rem;}
            }
        }
        .address-box{background: #fff;margin: .3rem auto 0; padding:.3rem 0 .5rem;display: none;
            .title{font-size: .28rem;text-align: center;}
            .line{width:1.3rem;height:.04rem;background: #44c7d2;margin: .05rem auto 0;}
            .list{overflow: hidden;margin-top: .3rem;text-align: center;
                .cen{display: inline-block;
                    .item{width:3.6rem;height:1.8rem; border-right:.02rem solid #f1f1f1;
                        .middle{width:3.73rem;height:1.8rem;
                            .icon{height:.8rem;text-align: center;
                                img{max-height: .8rem;}
                            }
                            .tit{margin-top:.2rem;}
                            .tit,.address{font-size:.22rem;line-height: .36rem; text-align: center;
                                a{color: #000;}
                            }
                        }
                    }
                    .item:nth-child(2n){border-right: none;}
                }
            }
        }
    }
    
    .link-blue {
        color: #0176ce !important;
        text-decoration: underline;
    }
</style>

